import React, { Component } from "react";
import './loading-text.component.css'
export class LoadingText extends Component {
    render() {
        const {loadingLabel}=this.props;
        return(
            <div className="loading">     
                    <h2>{loadingLabel}</h2>            
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
            </div>
        )
    }
}